import Vue from 'vue';
import VueTypes from 'vue-types';
import Promise from 'bluebird';
import Auth from 'src/auth.js';

let storage = {};

const storeComponent = Vue.extend({
	props: {
		name: VueTypes.string.def(null)
	},
	data() {
		return {
			items: [],
			isLoading: false
		};
	},
	computed: {
		storageKey() {
			return `${Auth.userId()}_${this.name}`;
		}
	},
	watch: {
		'items': {
			handler() {
				this.saveData();
			},
			deep: true
		}
	},
	created() {
		this.loadData();
	},
	methods: {
		saveData() {
			if (!this.isLoading) {
				window.localStorage[`store_${this.storageKey}`] = JSON.stringify(this.items);
			}
			return Promise.resolve(this.items);
		},
		loadData() {
			if (!this.isLoading) {
				this.isLoading = true;
				const localStorageData = window.localStorage[`store_${this.storageKey}`];
				this.items = [...(localStorageData && JSON.parse(localStorageData) || [])];
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.isLoading = false;
				});
			}
			return Promise.resolve(this.items);
		},
		push(item) {
			this.items.push(item);
			return Promise.resolve(item);
		}
	}
});

const propertyStoreComponent = Vue.extend({
	props: {
		name: VueTypes.string.def(null),
		customStorageKey: VueTypes.string.def(null),
	},
	data() {
		return {
			value: null,
			isLoading: false
		};
	},
	computed: {
		storageKey() {
			return `${this.customStorageKey || Auth.userId()}_${this.name}`;
		}
	},
	watch: {
		'value': {
			handler() {
				this.saveData();
			},
			deep: true
		}
	},
	created() {
		if (this.value)
			this.saveData();
		else
			this.loadData();
	},
	methods: {
		saveData() {
			window.localStorage[`property_${this.storageKey}`] = JSON.stringify(this.value);
			return Promise.resolve(this.value);
		},
		loadData() {
			if (!this.isLoading) {
				this.isLoading = true;
				const localStorageData = window.localStorage[`property_${this.storageKey}`];
				this.value = localStorageData && `${localStorageData}` !== 'undefined' && JSON.parse(localStorageData);
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.isLoading = false;
				});
			}
			return Promise.resolve(this.value);
		}
	}
});

function createStore(name) {
	if (__DEBUG__)
		console.info(`Create store for ${name}`);
	return new storeComponent({
		propsData: { name }
	});
}

function createPropertyStore(name, customStorageKey) {
	if (__DEBUG__)
		console.info(`Create store for ${name} ${customStorageKey}`);
	return new propertyStoreComponent({
		propsData: { name, customStorageKey }
	});
}

export default {
	get(name) {
		return !storage[name] ? storage[name] = createStore(name) : storage[name];
	},
	prop(name, customStorageKey, def) {
		customStorageKey = customStorageKey || Auth.userId() || '';
		if (!storage[`${customStorageKey || ''}_${name}`]) {
			storage[`${customStorageKey}_${name}`] = createPropertyStore(name, customStorageKey);			
		}
		var item = storage[`${customStorageKey}_${name}`];
		if (def != null && item.value == null) {
			item.value = def;
		}
		return item;
	}
};
